<div>
  <mat-card appearance="outlined" class="page page-narrow">
    @if (isEntitlementRequestable) {
      <mat-card-subtitle>
        {{ 'APP_INSUFFICIENT_PERMISSION.REQUEST_ACCESS_TITLE' | translate }}
      </mat-card-subtitle>
      <mat-card-subtitle>
        {{ 'APP_INSUFFICIENT_PERMISSION.REQUEST_ACCESS_DESCRIPTION' | translate }}
      </mat-card-subtitle>

      <button mat-raised-button class="footer" type="button" color="accent" (click)="openAccessDialog()">
        {{ 'APP_INSUFFICIENT_PERMISSION.REQUEST_ACCESS_BUTTON' | translate }}
      </button>
    } @else {
      <mat-card-subtitle>
        {{ 'APP_INSUFFICIENT_PERMISSION.TITLE' | translate }}
      </mat-card-subtitle>
      <mat-card-subtitle>
        {{ 'APP_INSUFFICIENT_PERMISSION.SITE_ERROR' | translate }}
      </mat-card-subtitle>

      <a [href]="signinLink">
        <button
          mat-raised-button
          [style.visibility]="!!accountGroupId ? 'visible' : 'hidden'"
          class="footer"
          type="submit"
          color="accent"
        >
          {{ 'APP_INSUFFICIENT_PERMISSION.SIGN_IN' | translate }}
        </button>
      </a>
    }
  </mat-card>
</div>
